export default {"src":"/_next/static/media/footer-bg-pattern.42a831aa.svg","height":1071,"width":1620,"blurWidth":0,"blurHeight":0};